import type { LandingPageContent, ProgrammaticLandingPageConfig } from './types'
import type { SupportedLanguage } from '../../i18n'
import { SOLARANLAGE_KOSTEN } from './solaranlage-kosten'
import { PV_ANGEBOT_VERGLEICHEN } from './pv-angebot-vergleichen'
import { PHOTOVOLTAIK_ANFRAGE_ERSTELLEN } from './photovoltaik-anfrage-erstellen'
import { PV_INSTALLATEUR_FINDEN } from './pv-installateur-finden'
import { PHOTOVOLTAIK_PLANEN } from './photovoltaik-planen'
import { PV_MODUL_MONTAGE } from './pv-module-montage'
import { PHOTOVOLTAIK_ELEKTROINSTALLATION } from './photovoltaik-elektroinstallation'
// GitLab-Issue #147: eigener Auftragstyp/Landingpage für PV-Selbstmontierer, die nur noch VDE-
// Abnahme + Netzbetreiber-Anmeldung brauchen - zunächst DE-only (siehe Datei-Kommentar), analog zum
// B2B-Howto-Topic oben.
import { PHOTOVOLTAIK_ABNAHME_ANMELDUNG } from './photovoltaik-abnahme-anmeldung'
import { PHOTOVOLTAIK_OHNE_TELEFONNUMMER } from './photovoltaik-ohne-telefonnummer'
// SEO-4.0-Story Task 01 (docs/tasks/active/seo/seo-4.0/01-waermepumpe-content-cluster.md): OrderType.WAERMEPUMPE
// is fully integrated in the product but had no dedicated landing page - closes that gap.
import { PHOTOVOLTAIK_WAERMEPUMPE } from './photovoltaik-waermepumpe'
import { FOTOVOLTAICA_BOMBA_DE_CALOR } from './es/fotovoltaica-bomba-de-calor'
import { FOTOWOLTAIKA_POMPA_CIEPLA } from './pl/fotowoltaika-pompa-ciepla'
// SEO-4.0-Story Task 02+09 (docs/tasks/active/seo/seo-4.0/02-wallbox-wechselrichter-sichtbarkeit.md +
// 09-eauto-ueberschussladen-kraftstoffvergleich.md): kombinierte Wallbox+E-Auto-Seite statt zweier
// sich überschneidender Einzelseiten - beide Tasks gemeinsam entschieden.
import { PHOTOVOLTAIK_WALLBOX_ELEKTROAUTO } from './photovoltaik-wallbox-elektroauto'
import { FOTOVOLTAICA_WALLBOX_COCHE_ELECTRICO } from './es/fotovoltaica-wallbox-coche-electrico'
import { FOTOWOLTAIKA_WALLBOX_SAMOCHOD_ELEKTRYCZNY } from './pl/fotowoltaika-wallbox-samochod-elektryczny'
// SEO-4.0-Story Task 04 (docs/tasks/active/seo/seo-4.0/04-foerderung-cluster-entscheidung.md): zusätzlich
// zum bestehenden Blogartikel, der bleibt unverändert bestehen (Story-Leitplanke).
import { PHOTOVOLTAIK_FOERDERUNG } from './photovoltaik-foerderung'
import { AYUDAS_FOTOVOLTAICA } from './es/ayudas-fotovoltaica'
import { DOFINANSOWANIE_FOTOWOLTAIKI } from './pl/dofinansowanie-fotowoltaiki'
// SEO-4.0-Story Task 05 (docs/tasks/active/seo/seo-4.0/05-nischen-keywords-niedrige-konkurrenz.md):
// Handwerker-Akquise-Cluster - komplett andere Zielgruppe (Handwerksbetriebe statt Kunden),
// bislang keine einzige SEO-Landingpage dafür.
import { HANDWERKER_PHOTOVOLTAIK_AUFTRAEGE } from './handwerker-photovoltaik-auftraege'
import { ENCARGOS_FOTOVOLTAICA_INSTALADORES } from './es/encargos-fotovoltaica-instaladores'
import { ZLECENIA_FOTOWOLTAICZNE_DLA_INSTALATOROW } from './pl/zlecenia-fotowoltaiczne-dla-instalatorow'
import { COSTE_INSTALACION_FOTOVOLTAICA } from './es/coste-instalacion-fotovoltaica'
import { COMPARAR_PRESUPUESTOS_FOTOVOLTAICOS } from './es/comparar-presupuestos-fotovoltaicos'
import { SOLICITAR_PRESUPUESTO_FOTOVOLTAICO } from './es/solicitar-presupuesto-fotovoltaico'
import { ENCONTRAR_INSTALADOR_FOTOVOLTAICO } from './es/encontrar-instalador-fotovoltaico'
import { PLANIFICAR_INSTALACION_FOTOVOLTAICA } from './es/planificar-instalacion-fotovoltaica'
import { MONTAJE_PANELES_SOLARES } from './es/montaje-paneles-solares'
import { INSTALACION_ELECTRICA_FOTOVOLTAICA } from './es/instalacion-electrica-fotovoltaica'
import { PRESUPUESTO_FOTOVOLTAICO_SIN_TELEFONO } from './es/presupuesto-fotovoltaico-sin-telefono'
import { KOSZT_INSTALACJI_FOTOWOLTAICZNEJ } from './pl/koszt-instalacji-fotowoltaicznej'
import { POROWNAJ_OFERTY_FOTOWOLTAICZNE } from './pl/porownaj-oferty-fotowoltaiczne'
import { ZLOZYC_ZAPYTANIE_FOTOWOLTAICZNE } from './pl/zlozyc-zapytanie-fotowoltaiczne'
import { ZNAJDZ_INSTALATORA_FOTOWOLTAIKI } from './pl/znajdz-instalatora-fotowoltaiki'
import { ZAPLANUJ_INSTALACJE_FOTOWOLTAICZNA } from './pl/zaplanuj-instalacje-fotowoltaiczna'
import { MONTAZ_PANELI_FOTOWOLTAICZNYCH } from './pl/montaz-paneli-fotowoltaicznych'
import { INSTALACJA_ELEKTRYCZNA_FOTOWOLTAIKI } from './pl/instalacja-elektryczna-fotowoltaiki'
import { OFERTA_FOTOWOLTAICZNA_BEZ_TELEFONU } from './pl/oferta-fotowoltaiczna-bez-telefonu'
// pSEO-Story Task 07 (Structured Data & E-E-A-T): Methodik-/Transparenz-Seite für den
// PV-Kostenrechner - fester Themen-Slug, kein programmatic Achsen-Eintrag.
import { METHODIK_PREISBERECHNUNG } from './methodik-preisberechnung'
import { COMO_CALCULAMOS_EL_PRECIO } from './es/como-calculamos-el-precio'
import { JAK_OBLICZAMY_CENE } from './pl/jak-obliczamy-cene'
// GitLab-Issue #143 (Sub-Issue von #142): Schritt-für-Schritt-How-to-Seite für Kunden, fester
// Themen-Slug wie METHODIK_PREISBERECHNUNG oben, kein programmatic Achsen-Eintrag.
import { SO_FUNKTIONIERT_ES_FUER_KUNDEN } from './so-funktioniert-es-fuer-kunden'
import { COMO_FUNCIONA_PARA_CLIENTES } from './es/como-funciona-para-clientes'
import { JAK_DZIALA_DLA_KLIENTOW } from './pl/jak-dziala-dla-klientow'
// GitLab-Issue #144 (Sub-Issue von #142): Handwerker-Pendant zu #143 oben.
import { SO_FUNKTIONIERT_ES_FUER_HANDWERKER } from './so-funktioniert-es-fuer-handwerker'
import { COMO_FUNCIONA_PARA_INSTALADORES } from './es/como-funciona-para-instaladores'
import { JAK_DZIALA_DLA_INSTALATOROW } from './pl/jak-dziala-dla-instalatorow'
// GitLab-Issue #145 (Schritt 5): B2B-Marktplatz-Pendant zu #143/#144 oben - zunächst DE-only,
// ES/PL-Varianten als Folgeschritt (siehe Datei-Kommentar).
import { SO_FUNKTIONIERT_ES_FUER_B2B_MARKTPLATZ } from './so-funktioniert-es-fuer-b2b-marktplatz'
// pSEO-Story Task 04 pilot: 7 kWp sizes x DE/ES/PL, see programmatic/kwpSizeFacts.ts for the
// shared Richtwerte all 21 pages draw on.
import { KWP_5_PHOTOVOLTAIK_KOSTEN } from './programmatic/5-kwp-photovoltaik-kosten'
import { KWP_8_PHOTOVOLTAIK_KOSTEN } from './programmatic/8-kwp-photovoltaik-kosten'
import { KWP_10_PHOTOVOLTAIK_KOSTEN } from './programmatic/10-kwp-photovoltaik-kosten'
import { KWP_12_PHOTOVOLTAIK_KOSTEN } from './programmatic/12-kwp-photovoltaik-kosten'
import { KWP_15_PHOTOVOLTAIK_KOSTEN } from './programmatic/15-kwp-photovoltaik-kosten'
import { KWP_20_PHOTOVOLTAIK_KOSTEN } from './programmatic/20-kwp-photovoltaik-kosten'
import { KWP_25_PHOTOVOLTAIK_KOSTEN } from './programmatic/25-kwp-photovoltaik-kosten'
import { KWP_5_INSTALACION_FOTOVOLTAICA } from './programmatic/es/instalacion-fotovoltaica-5-kwp-precio'
import { KWP_8_INSTALACION_FOTOVOLTAICA } from './programmatic/es/instalacion-fotovoltaica-8-kwp-precio'
import { KWP_10_INSTALACION_FOTOVOLTAICA } from './programmatic/es/instalacion-fotovoltaica-10-kwp-precio'
import { KWP_12_INSTALACION_FOTOVOLTAICA } from './programmatic/es/instalacion-fotovoltaica-12-kwp-precio'
import { KWP_15_INSTALACION_FOTOVOLTAICA } from './programmatic/es/instalacion-fotovoltaica-15-kwp-precio'
import { KWP_20_INSTALACION_FOTOVOLTAICA } from './programmatic/es/instalacion-fotovoltaica-20-kwp-precio'
import { KWP_25_INSTALACION_FOTOVOLTAICA } from './programmatic/es/instalacion-fotovoltaica-25-kwp-precio'
import { KWP_5_INSTALACJA_FOTOWOLTAICZNA } from './programmatic/pl/instalacja-fotowoltaiczna-5-kwp-cena'
import { KWP_8_INSTALACJA_FOTOWOLTAICZNA } from './programmatic/pl/instalacja-fotowoltaiczna-8-kwp-cena'
import { KWP_10_INSTALACJA_FOTOWOLTAICZNA } from './programmatic/pl/instalacja-fotowoltaiczna-10-kwp-cena'
import { KWP_12_INSTALACJA_FOTOWOLTAICZNA } from './programmatic/pl/instalacja-fotowoltaiczna-12-kwp-cena'
import { KWP_15_INSTALACJA_FOTOWOLTAICZNA } from './programmatic/pl/instalacja-fotowoltaiczna-15-kwp-cena'
import { KWP_20_INSTALACJA_FOTOWOLTAICZNA } from './programmatic/pl/instalacja-fotowoltaiczna-20-kwp-cena'
import { KWP_25_INSTALACJA_FOTOWOLTAICZNA } from './programmatic/pl/instalacja-fotowoltaiczna-25-kwp-cena'
// pSEO-Story Task 05: 6 kWh storage sizes x DE/ES/PL, coupled to a 10-kWp reference installation
// (see programmatic/storageSizeFacts.ts for the shared numeric constants all 18 pages draw on).
import { KWH_5_SPEICHER_KOSTEN } from './programmatic/5-kwh-speicher-kosten'
import { KWH_7_SPEICHER_KOSTEN } from './programmatic/7-kwh-speicher-kosten'
import { KWH_10_SPEICHER_KOSTEN } from './programmatic/10-kwh-speicher-kosten'
import { KWH_12_SPEICHER_KOSTEN } from './programmatic/12-kwh-speicher-kosten'
import { KWH_15_SPEICHER_KOSTEN } from './programmatic/15-kwh-speicher-kosten'
import { KWH_20_SPEICHER_KOSTEN } from './programmatic/20-kwh-speicher-kosten'
import { KWH_5_BATERIA_SOLAR } from './programmatic/es/bateria-solar-5-kwh-precio'
import { KWH_7_BATERIA_SOLAR } from './programmatic/es/bateria-solar-7-kwh-precio'
import { KWH_10_BATERIA_SOLAR } from './programmatic/es/bateria-solar-10-kwh-precio'
import { KWH_12_BATERIA_SOLAR } from './programmatic/es/bateria-solar-12-kwh-precio'
import { KWH_15_BATERIA_SOLAR } from './programmatic/es/bateria-solar-15-kwh-precio'
import { KWH_20_BATERIA_SOLAR } from './programmatic/es/bateria-solar-20-kwh-precio'
import { KWH_5_MAGAZYN_ENERGII } from './programmatic/pl/magazyn-energii-5-kwh-cena'
import { KWH_7_MAGAZYN_ENERGII } from './programmatic/pl/magazyn-energii-7-kwh-cena'
import { KWH_10_MAGAZYN_ENERGII } from './programmatic/pl/magazyn-energii-10-kwh-cena'
import { KWH_12_MAGAZYN_ENERGII } from './programmatic/pl/magazyn-energii-12-kwh-cena'
import { KWH_15_MAGAZYN_ENERGII } from './programmatic/pl/magazyn-energii-15-kwh-cena'
import { KWH_20_MAGAZYN_ENERGII } from './programmatic/pl/magazyn-energii-20-kwh-cena'
// SEO-4.0-Story Task 08 (docs/tasks/active/seo/seo-4.0/08-staedte-rollout-pilot.md): 250 DE-only
// city-yield pages, generated from PVGIS data instead of hand-written per file (see that module's
// own doc comment) - a single array import, not 250 named imports like the size-series pages above.
import { STAEDTE_ERTRAG_PAGES } from './programmatic/staedteErtrag'

export type {
  LandingPageContent,
  LandingPageSection,
  LandingPageFaqItem,
  LandingPageCta,
  LandingPageLink,
  ProgrammaticLandingPageConfig,
  CalculatorAxis,
  IndexPolicy,
  AnyLandingPageContent,
} from './types'
export { INDEXED_KWP_STEPS, INDEXED_STORAGE_STEPS_KWH } from './types'
export {
  SOLARANLAGE_KOSTEN,
  PV_ANGEBOT_VERGLEICHEN,
  PHOTOVOLTAIK_ANFRAGE_ERSTELLEN,
  PV_INSTALLATEUR_FINDEN,
  PHOTOVOLTAIK_PLANEN,
  PV_MODUL_MONTAGE,
  PHOTOVOLTAIK_ELEKTROINSTALLATION,
  PHOTOVOLTAIK_ABNAHME_ANMELDUNG,
  PHOTOVOLTAIK_OHNE_TELEFONNUMMER,
  PHOTOVOLTAIK_WAERMEPUMPE,
  FOTOVOLTAICA_BOMBA_DE_CALOR,
  FOTOWOLTAIKA_POMPA_CIEPLA,
  PHOTOVOLTAIK_WALLBOX_ELEKTROAUTO,
  FOTOVOLTAICA_WALLBOX_COCHE_ELECTRICO,
  FOTOWOLTAIKA_WALLBOX_SAMOCHOD_ELEKTRYCZNY,
  PHOTOVOLTAIK_FOERDERUNG,
  AYUDAS_FOTOVOLTAICA,
  DOFINANSOWANIE_FOTOWOLTAIKI,
  HANDWERKER_PHOTOVOLTAIK_AUFTRAEGE,
  ENCARGOS_FOTOVOLTAICA_INSTALADORES,
  ZLECENIA_FOTOWOLTAICZNE_DLA_INSTALATOROW,
  COSTE_INSTALACION_FOTOVOLTAICA,
  COMPARAR_PRESUPUESTOS_FOTOVOLTAICOS,
  SOLICITAR_PRESUPUESTO_FOTOVOLTAICO,
  ENCONTRAR_INSTALADOR_FOTOVOLTAICO,
  PLANIFICAR_INSTALACION_FOTOVOLTAICA,
  MONTAJE_PANELES_SOLARES,
  INSTALACION_ELECTRICA_FOTOVOLTAICA,
  PRESUPUESTO_FOTOVOLTAICO_SIN_TELEFONO,
  KOSZT_INSTALACJI_FOTOWOLTAICZNEJ,
  POROWNAJ_OFERTY_FOTOWOLTAICZNE,
  ZLOZYC_ZAPYTANIE_FOTOWOLTAICZNE,
  ZNAJDZ_INSTALATORA_FOTOWOLTAIKI,
  ZAPLANUJ_INSTALACJE_FOTOWOLTAICZNA,
  MONTAZ_PANELI_FOTOWOLTAICZNYCH,
  INSTALACJA_ELEKTRYCZNA_FOTOWOLTAIKI,
  OFERTA_FOTOWOLTAICZNA_BEZ_TELEFONU,
  METHODIK_PREISBERECHNUNG,
  COMO_CALCULAMOS_EL_PRECIO,
  JAK_OBLICZAMY_CENE,
  SO_FUNKTIONIERT_ES_FUER_KUNDEN,
  COMO_FUNCIONA_PARA_CLIENTES,
  JAK_DZIALA_DLA_KLIENTOW,
  SO_FUNKTIONIERT_ES_FUER_HANDWERKER,
  COMO_FUNCIONA_PARA_INSTALADORES,
  JAK_DZIALA_DLA_INSTALATOROW,
  SO_FUNKTIONIERT_ES_FUER_B2B_MARKTPLATZ,
  KWP_5_PHOTOVOLTAIK_KOSTEN,
  KWP_8_PHOTOVOLTAIK_KOSTEN,
  KWP_10_PHOTOVOLTAIK_KOSTEN,
  KWP_12_PHOTOVOLTAIK_KOSTEN,
  KWP_15_PHOTOVOLTAIK_KOSTEN,
  KWP_20_PHOTOVOLTAIK_KOSTEN,
  KWP_25_PHOTOVOLTAIK_KOSTEN,
  KWP_5_INSTALACION_FOTOVOLTAICA,
  KWP_8_INSTALACION_FOTOVOLTAICA,
  KWP_10_INSTALACION_FOTOVOLTAICA,
  KWP_12_INSTALACION_FOTOVOLTAICA,
  KWP_15_INSTALACION_FOTOVOLTAICA,
  KWP_20_INSTALACION_FOTOVOLTAICA,
  KWP_25_INSTALACION_FOTOVOLTAICA,
  KWP_5_INSTALACJA_FOTOWOLTAICZNA,
  KWP_8_INSTALACJA_FOTOWOLTAICZNA,
  KWP_10_INSTALACJA_FOTOWOLTAICZNA,
  KWP_12_INSTALACJA_FOTOWOLTAICZNA,
  KWP_15_INSTALACJA_FOTOWOLTAICZNA,
  KWP_20_INSTALACJA_FOTOWOLTAICZNA,
  KWP_25_INSTALACJA_FOTOWOLTAICZNA,
  KWH_5_SPEICHER_KOSTEN,
  KWH_7_SPEICHER_KOSTEN,
  KWH_10_SPEICHER_KOSTEN,
  KWH_12_SPEICHER_KOSTEN,
  KWH_15_SPEICHER_KOSTEN,
  KWH_20_SPEICHER_KOSTEN,
  KWH_5_BATERIA_SOLAR,
  KWH_7_BATERIA_SOLAR,
  KWH_10_BATERIA_SOLAR,
  KWH_12_BATERIA_SOLAR,
  KWH_15_BATERIA_SOLAR,
  KWH_20_BATERIA_SOLAR,
  KWH_5_MAGAZYN_ENERGII,
  KWH_7_MAGAZYN_ENERGII,
  KWH_10_MAGAZYN_ENERGII,
  KWH_12_MAGAZYN_ENERGII,
  KWH_15_MAGAZYN_ENERGII,
  KWH_20_MAGAZYN_ENERGII,
}

/** SEO landing pages targeting high-intent PV search terms, registered as top-level routes in
 *  App.tsx (same bare-URL pattern as /blog and /pv-rechner - see content/landingPages/types.ts for
 *  why each language uses its own locally-appropriate slug rather than a shared /:lang/ prefix).
 *  15 topics x 3 languages (DE/ES/PL), plus 2 deliberately DE-only topics = 47 pages, grouped by topicId for hreflang (see
 *  seo/useLandingPageSeo.ts) and for the language switcher (see LanguageSwitcher.tsx). */
export const LANDING_PAGES: LandingPageContent[] = [
  SOLARANLAGE_KOSTEN,
  PV_ANGEBOT_VERGLEICHEN,
  PHOTOVOLTAIK_ANFRAGE_ERSTELLEN,
  PV_INSTALLATEUR_FINDEN,
  PHOTOVOLTAIK_PLANEN,
  PV_MODUL_MONTAGE,
  PHOTOVOLTAIK_ELEKTROINSTALLATION,
  PHOTOVOLTAIK_ABNAHME_ANMELDUNG,
  PHOTOVOLTAIK_OHNE_TELEFONNUMMER,
  PHOTOVOLTAIK_WAERMEPUMPE,
  FOTOVOLTAICA_BOMBA_DE_CALOR,
  FOTOWOLTAIKA_POMPA_CIEPLA,
  PHOTOVOLTAIK_WALLBOX_ELEKTROAUTO,
  FOTOVOLTAICA_WALLBOX_COCHE_ELECTRICO,
  FOTOWOLTAIKA_WALLBOX_SAMOCHOD_ELEKTRYCZNY,
  PHOTOVOLTAIK_FOERDERUNG,
  AYUDAS_FOTOVOLTAICA,
  DOFINANSOWANIE_FOTOWOLTAIKI,
  HANDWERKER_PHOTOVOLTAIK_AUFTRAEGE,
  ENCARGOS_FOTOVOLTAICA_INSTALADORES,
  ZLECENIA_FOTOWOLTAICZNE_DLA_INSTALATOROW,
  COSTE_INSTALACION_FOTOVOLTAICA,
  COMPARAR_PRESUPUESTOS_FOTOVOLTAICOS,
  SOLICITAR_PRESUPUESTO_FOTOVOLTAICO,
  ENCONTRAR_INSTALADOR_FOTOVOLTAICO,
  PLANIFICAR_INSTALACION_FOTOVOLTAICA,
  MONTAJE_PANELES_SOLARES,
  INSTALACION_ELECTRICA_FOTOVOLTAICA,
  PRESUPUESTO_FOTOVOLTAICO_SIN_TELEFONO,
  KOSZT_INSTALACJI_FOTOWOLTAICZNEJ,
  POROWNAJ_OFERTY_FOTOWOLTAICZNE,
  ZLOZYC_ZAPYTANIE_FOTOWOLTAICZNE,
  ZNAJDZ_INSTALATORA_FOTOWOLTAIKI,
  ZAPLANUJ_INSTALACJE_FOTOWOLTAICZNA,
  MONTAZ_PANELI_FOTOWOLTAICZNYCH,
  INSTALACJA_ELEKTRYCZNA_FOTOWOLTAIKI,
  OFERTA_FOTOWOLTAICZNA_BEZ_TELEFONU,
  METHODIK_PREISBERECHNUNG,
  COMO_CALCULAMOS_EL_PRECIO,
  JAK_OBLICZAMY_CENE,
  SO_FUNKTIONIERT_ES_FUER_KUNDEN,
  COMO_FUNCIONA_PARA_CLIENTES,
  JAK_DZIALA_DLA_KLIENTOW,
  SO_FUNKTIONIERT_ES_FUER_HANDWERKER,
  COMO_FUNCIONA_PARA_INSTALADORES,
  JAK_DZIALA_DLA_INSTALATOROW,
  SO_FUNKTIONIERT_ES_FUER_B2B_MARKTPLATZ,
]

export function getLandingPageBySlug(slug: string): LandingPageContent | undefined {
  return LANDING_PAGES.find((page) => page.slug === slug)
}

/** All language variants of the same topic, e.g. every page about PV costs (DE/ES/PL) - used to
 *  build the hreflang cluster for a given page (see useLandingPageSeo.ts). */
export function getLandingPagesByTopic(topicId: string): LandingPageContent[] {
  return LANDING_PAGES.filter((page) => page.topicId === topicId)
}

/** The sibling of `page` in `targetLang`, if a translation exists - used by the language switcher
 *  to jump to the equivalent page instead of just the target language's homepage. */
export function getLandingPageSibling(
  page: LandingPageContent,
  targetLang: SupportedLanguage,
): LandingPageContent | undefined {
  return LANDING_PAGES.find((p) => p.topicId === page.topicId && p.lang === targetLang)
}

/** Programmatic (datengetriebene) Landingpages der pSEO-Story (siehe
 *  docs/tasks/active/seo/programmatic-seo/README.md) - bewusst getrennt von LANDING_PAGES gehalten (Task 01),
 *  damit die bestehenden, von Hand geschriebenen Themenseiten getrennt bleiben.
 *  Task 04 ("nach Anlagengröße"): 7 kWp-Pilot-Stufen (5/8/10/12/15/20/25, siehe
 *  programmatic/kwpSizeFacts.ts PILOT_KWP_VALUES) x DE/ES/PL = 21 Seiten.
 *  Task 05 ("nach Speichergröße"): 6 kWh-Speicherstufen (5/7/10/12/15/20, siehe
 *  programmatic/storageSizeFacts.ts PILOT_STORAGE_KWH_VALUES) x DE/ES/PL = 18 Seiten, jede an
 *  eine 10-kWp-Referenzanlage gekoppelt statt als eigenständige Speicher-Solo-Seite (Task-05-
 *  Entscheidung, siehe Task-Dokument). Insgesamt 39 programmatische Seiten. */
export const PROGRAMMATIC_LANDING_PAGES: ProgrammaticLandingPageConfig[] = [
  KWP_5_PHOTOVOLTAIK_KOSTEN,
  KWP_8_PHOTOVOLTAIK_KOSTEN,
  KWP_10_PHOTOVOLTAIK_KOSTEN,
  KWP_12_PHOTOVOLTAIK_KOSTEN,
  KWP_15_PHOTOVOLTAIK_KOSTEN,
  KWP_20_PHOTOVOLTAIK_KOSTEN,
  KWP_25_PHOTOVOLTAIK_KOSTEN,
  KWP_5_INSTALACION_FOTOVOLTAICA,
  KWP_8_INSTALACION_FOTOVOLTAICA,
  KWP_10_INSTALACION_FOTOVOLTAICA,
  KWP_12_INSTALACION_FOTOVOLTAICA,
  KWP_15_INSTALACION_FOTOVOLTAICA,
  KWP_20_INSTALACION_FOTOVOLTAICA,
  KWP_25_INSTALACION_FOTOVOLTAICA,
  KWP_5_INSTALACJA_FOTOWOLTAICZNA,
  KWP_8_INSTALACJA_FOTOWOLTAICZNA,
  KWP_10_INSTALACJA_FOTOWOLTAICZNA,
  KWP_12_INSTALACJA_FOTOWOLTAICZNA,
  KWP_15_INSTALACJA_FOTOWOLTAICZNA,
  KWP_20_INSTALACJA_FOTOWOLTAICZNA,
  KWP_25_INSTALACJA_FOTOWOLTAICZNA,
  KWH_5_SPEICHER_KOSTEN,
  KWH_7_SPEICHER_KOSTEN,
  KWH_10_SPEICHER_KOSTEN,
  KWH_12_SPEICHER_KOSTEN,
  KWH_15_SPEICHER_KOSTEN,
  KWH_20_SPEICHER_KOSTEN,
  KWH_5_BATERIA_SOLAR,
  KWH_7_BATERIA_SOLAR,
  KWH_10_BATERIA_SOLAR,
  KWH_12_BATERIA_SOLAR,
  KWH_15_BATERIA_SOLAR,
  KWH_20_BATERIA_SOLAR,
  KWH_5_MAGAZYN_ENERGII,
  KWH_7_MAGAZYN_ENERGII,
  KWH_10_MAGAZYN_ENERGII,
  KWH_12_MAGAZYN_ENERGII,
  KWH_15_MAGAZYN_ENERGII,
  KWH_20_MAGAZYN_ENERGII,
  ...STAEDTE_ERTRAG_PAGES,
]

export function getProgrammaticLandingPageBySlug(slug: string): ProgrammaticLandingPageConfig | undefined {
  return PROGRAMMATIC_LANDING_PAGES.find((page) => page.slug === slug)
}

/** Pendant zu getLandingPagesByTopic, für die programmatic-Registry - siehe useLandingPageSeo.ts,
 *  das beide Registries für die hreflang-Cluster-Suche zusammenführt. */
export function getProgrammaticLandingPagesByTopic(topicId: string): ProgrammaticLandingPageConfig[] {
  return PROGRAMMATIC_LANDING_PAGES.filter((page) => page.topicId === topicId)
}
